import { useQuery } from "@tanstack/react-query";

import { useRequestWithFeedback } from "../../../composites";
import { useLibrary } from "../../../providers";

import TransactionsAPI from "./api";

import type { AnyException, OverrideRunProps } from "../../../composites";
import type { GetTransactionResponse } from "./types";

export const useGetTransaction = (
  transactionId: string,
  overrideRunProps?: OverrideRunProps<GetTransactionResponse>,
) => {
  const { send } = useRequestWithFeedback<
    GetTransactionResponse,
    AnyException
  >();
  const l10n = useLibrary("translations");

  const { data, isLoading } = useQuery({
    enabled: !!transactionId,
    queryKey: ["transaction_detail", transactionId],
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    queryFn: async (): Promise<GetTransactionResponse | undefined> => {
      const result = await send({
        action: TransactionsAPI.getTransaction(transactionId),
        messaging: {
          toast: {
            error: l10n.getString("transaction-fetch-error"),
          },
        },
        ...overrideRunProps,
      });
      return result ?? undefined;
    },
  });

  return { data, loading: isLoading };
};
